import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-empresa-redirect',
  template: '<p>Redirigiendo...</p>'
})
export class EmpresaRedirectComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const partner = (this.route.snapshot.paramMap.get('alias') || '').trim().toLowerCase();

    if (!partner) {
      this.router.navigate(['/home']);
      return;
    }

    try {
      sessionStorage.setItem('homeFrom', partner);
    } catch (e) {
      // ignore storage errors
    }

    // navigate to home route with query param so existing logic still sees ?from=partner
    this.router.navigate(['/home'], { queryParams: { from: partner } });
  }
}
